import React from 'react';
import { Box } from 'rebass';
import Details from '../../Details';
import Link from '../../app/components/link';
import Testimonial from '../../app/components/testimonial';
import Lead from '../../Lead';
import testimonials from '../../app/data/testimonials';

const tags = [
  'Creative Ad Agency',
  'Web Application',
  'Project Management',
  'Ember.js',
  'Ember Data',
  'Rich-text Editor',
  'UI Design',
  'CSS',
];

export default () => (
  <div>
    <Details
      title="Victors & Spoils"
      subtitle="Advertising Services"
    >
      <Details.Paragraph emoji="🎨" title="A project management tool for creative agencies">
        <Link target="_blank" href="https://www.victorsandspoils.com/">Victors & Spoils
      </Link> wanted an application to assist in the process of creating and managing
        advertising campaigns for its clients. The creative process typically requires collaboration
        between several different roles, and involves a lot of back and forth with the client. The
        challenge was to build a web-based tool that captures the whole creative process,
        from ideation, to refinement, to delivery.
      </Details.Paragraph>
      <Details.Paragraph emoji="❤️" title="Custom built from the ground up">
        We worked with Victors & Spoils to develop a web application for facilitating the process
        of creating and launching ad campaigns, and managing an army of creatives, producers,
        account managers and directors. The end product includes a rich-text editor
        for creating documents and collaborate with others in real-time, a novel interface for
        simulating a creative agency&apos;s brainstorming board, and a sophisticated role-based
        system for controlling access to content.
      </Details.Paragraph>
      <Details.Paragraph emoji="💰" title="An award winning advertising agency">
        Victors & Spoils is the world&apos;s first creative advertising agency built on
        crowdsourcing. They manage and curate a crowd of more than 6,000 talented creatives
        throughout the globe. V&S&apos;s client roster includes Coca-Cola, Converse, Crocs,
        Discovery Channel, GAP, Harley Davidson, Mercedes Benz, Oakley, PayPal, and WD-40.
        V&S was founded in 2009 and is based in Boulder, Colorado.
      </Details.Paragraph>
      <Details.Tags tags={tags} />
      <Box style={{ maxWidth: '660px' }}>
        <Testimonial {...testimonials.robertReich} />
        <Testimonial {...testimonials.davide} />
        <Testimonial {...testimonials.salvatore} />
      </Box>
      <Box mt={5}>
        <Lead />
      </Box>
    </Details>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/work/vands.js